import differenceInYears from 'date-fns/differenceInYears';

export const getFullProductsFieldName = (name: string) => `${name}Array`;

export const isAgeWithinInterval = (date: string, interval: [number, number]) => {
    try {
        if (!date || !interval) {
            return false;
        }

        const [day, month, year] = date.split('.');
        const monthIndex = Number(month) - 1;

        const diff = differenceInYears(new Date(), new Date(Number(year), monthIndex, Number(day)));

        const [startAge, endAge] = interval;

        return Boolean(diff >= startAge && diff <= endAge);
    } catch (e) {
        console.error(e);

        return false;
    }
};
